var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMovieTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 77,
    viewBox: "0 0 77 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 77,
    height: 77,
    fill: "url(#pattern0_913_273)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_913_273",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_913_273",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_913_273",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAADWUlEQVR4nO3cTUsVUQDGcUXTkkDUpEUiUUb7WkelvVNfIcpWQRb4DapN0CeQylYtW0itiorMl2qRKbTJXhYFBWZR1i77x4Fjd7BxvDNz5szM9fnB7O7Mfc5zh3m/U1cnIiIiIiIiIiIiIlGA9cAF4BnwE1liungKnAeaU61FQBcw/W/RspKXpqs0a7JKjld2/DXbbi4knoEkRZttssQzmaTohZhfIrCQpGhJQEV7oqI9UdGeqGhPVLQntVT0azsVUq0UfQeot9NdCqhWij4eyHeCAqqFor8FL9oATcA8BVMLRQ+HZLxJwdRC0UdCMh6lYMpe9FezqQjJuA74QoGUvehrETmvUyBlL/pgRM5DlLzocYphDmiMyNloP1MEY7GLtoM4ALzNOfxQFTmHcs74BuhLVHJgEB3ARI6D6KsiY1+O+caA9lQlBwbSDsw6CPUHOAv0ANsCk/kx25ZNrQlytoYsp2PZd/XYDCZLWuaaS5uTkgOD2Ocg3Iu6grCPB6RhutiTVbiHKcPNJ37QxO04uuyxeRr3swzYT3qfzU42s5DV7eBNhrROZRlyJ24sApeBhszC/p+9wX6n+W4XdmQZtgW3HgNbMgtcyb0ZuOc4+4YsA2/EvTngWIaZzaHfpwxyt5Rh0xG2B78SdQaYIGujXaaLwzjvm44zZGsc6HaQs9vDJYTTbloNH8AjsvfR3BNMkbHeLiNrD9y2WxnAfvwYcZB1xENOs0na66bdSvAOe+HEh/6CHO9XY9bldY5N9r8aPvwGOh1k7rTL8mHSrIhpAx8G3uPPaNqSA9lHPeZ+Z25AJA2ax6XRQYdFD+aQfyJJ0Dxsr+LY+JKdIo+5zbLyGEAZip5eJc9W4Eng889XO2kAZnwPogxFX4zIchL4ETLPL/PvsYj5zJrvVRmK3rXCHZNbVcx7O2zPD+zGs6IX/WH52SDQG/MMz3y2N+Qs0Szbm6IXPbNUtH148WrC68aLdt6mQNGv8KjoRRs37LZ4ivSm7LKG8awMRdcEFe2JivZERXuioj1R0Z6oaE9UdIGL1otR4vuepGi96sfTq37M+9wknnNJim528AzxWjIV9he9OM8Rq+zqSk73sKZdswfsbXXtICsW7A3sc4nXZBEREREREREREZG6NeMvGGTIA/oYE+sAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMovieTicket);
export default __webpack_public_path__ + "static/media/movie_ticket.ab5ca8c2c7c9dc9e69d6e789cdef4986.svg";
export { ForwardRef as ReactComponent };